import { createAction, props } from '@ngrx/store';

export const loadIdentityDocumentTypes = createAction('[IdentityDocumentType] Load IdentityDocumentTypes');

export const loadIdentityDocumentTypesSuccess = createAction('[IdentityDocumentType] Load IdentityDocumentTypes Success', props<{ response: any }>());

export const loadIdentityDocumentTypesFailure = createAction('[IdentityDocumentType] Load IdentityDocumentTypes Failure', props<{ error: Error | any }>());
